import { useMutation } from "urql";

import { UpdateIdpFdDocument } from "../../../graphql/generated.ts";
import {
  DocumentType,
  JSONValue,
} from "../../../pages/IDPForgeryCheck/types.ts";
import { mapDocumentTypeToDocType } from "../../../pages/IDPForgeryCheck/utils.ts";

export function useUpdateIdpFdDocument() {
  const [{ data, fetching, error }, executeUpdate] =
    useMutation(UpdateIdpFdDocument);

  const updateIdpResult = async (
    id: number,
    updatedData: JSONValue,
    documentType: DocumentType
  ) => {
    try {
      const mappedDocType = mapDocumentTypeToDocType(documentType);

      const result = await executeUpdate({
        id,
        input: {
          idpResult: updatedData,
          documentType: mappedDocType,
        },
      });

      if (result.error) {
        console.error("Error updating IDP result:", result.error);
        throw new Error(result.error.message);
      }

      return result.data;
    } catch (error) {
      console.error("Failed to update IDP result:", error);
      throw error;
    }
  };

  return {
    updateIdpResult,
    data,
    loading: fetching,
    error,
  };
}
